import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.brightGreen,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.brightGreen,
  iconBorderColor: colors.brightGreen,
  iconBorderHoverColor: colors.brightGreen
};
export default socialIcon;